import { ProcessItem } from "./model";

export const ProcessList: ProcessItem[] = [
  {
    name: "营收",
    value: "income",
  },
  {
    name: "用户",
    value: "user",
  },
  {
    name: "转化",
    value: "convert",
  },
  {
    name: "流量",
    value: "flow",
  },
  {
    name: "交付",
    value: "deliver",
  },
];

export const placeholderOptions = {
  IDENTITY: [
    {
      value: "大学生",
      title: "大学生",
    },
    {
      value: "初中生",
      title: "初中生",
    },
    {
      value: "高中生",
      title: "高中生",
    },
    {
      value: "小学生",
      title: "小学生",
    },
    {
      value: "工作党",
      title: "工作党",
    },
    {
      value: "其他",
      title: "其他",
    },
    {
      value: "NULL",
      title: "NULL",
    },
  ],
  DEVICE_KIND: [
    {
      value: "android",
      title: "Android",
    },
    {
      value: "ipad",
      title: "iPad",
    },
    {
      value: "iphone",
      title: "iPhone",
    },
    {
      value: "NULL",
      title: "NULL",
    },
  ],
  SEX: [
    {
      value: "男",
      title: "男",
    },
    {
      value: "女",
      title: "女",
    },
    {
      value: "NULL",
      title: "NULL",
    },
  ],
  YES_OR_NO: [
    {
      value: "是",
      title: "是",
    },
    {
      value: "否",
      title: "否",
    },
    {
      value: "NULL",
      title: "NULL",
    },
  ],
  CITY_LEVEL: [
    {
      value: "一线城市",
      title: "一线城市",
    },
    {
      value: "新一线城市",
      title: "新一线城市",
    },
    {
      value: "二线城市",
      title: "二线城市",
    },
    {
      value: "三线城市",
      title: "三线城市",
    },
    {
      value: "四线城市",
      title: "四线城市",
    },
    {
      value: "五线城市",
      title: "五线城市",
    },
    {
      value: "NULL",
      title: "NULL",
    },
  ],
  DEVICE_PRICE: [
    {
      value: "500-999",
      title: "¥500-999",
    },
    {
      value: "1000-1499",
      title: "¥1000-1499",
    },
    {
      value: "1500-1999",
      title: "¥1500-1999",
    },
    {
      value: "2000-2999",
      title: "¥2000-2999",
    },
    {
      value: "3000-3999",
      title: "¥3000-3999",
    },
    {
      value: "4000-4999",
      title: "¥4000-4999",
    },
    {
      value: "5000+",
      title: "¥5000+",
    },
    {
      value: "NULL",
      title: "NULL",
    },
  ],
  AD_KIND: [
    {
      value: "实验广告",
      title: "prod",
    },
    {
      value: "正式广告",
      title: "test",
    },
  ],
  USER_GRADE: [
    { value: "幼儿园小班", title: "幼儿园小班" },
    { value: "幼儿园中班", title: "幼儿园中班" },
    { value: "幼儿园大班", title: "幼儿园大班" },
    { value: "小学一年级", title: "小学一年级" },
    { value: "小学二年级", title: "小学二年级" },
    { value: "小学三年级", title: "小学三年级" },
    { value: "小学四年级", title: "小学四年级" },
    { value: "小学五年级", title: "小学五年级" },
    { value: "小学六年级", title: "小学六年级" },
    { value: "初中一年级", title: "初中一年级" },
    { value: "初中二年级", title: "初中二年级" },
    { value: "初中三年级", title: "初中三年级" },
    { value: "高中一年级", title: "高中一年级" },
    { value: "高中二年级", title: "高中二年级" },
    { value: "高中三年级", title: "高中三年级" },
    { value: "大学生", title: "大学生" },
    { value: "大学一年级", title: "大学一年级" },
    { value: "大学二年级", title: "大学二年级" },
    { value: "大学三年级", title: "大学三年级" },
    { value: "大学四年级", title: "大学四年级" },
    { value: "研究生", title: "研究生" },
    { value: "博士生", title: "博士生" },
    { value: "NULL", title: "NULL" },
  ],
};

export function isTimeFormat(format: string): boolean {
  switch (format) {
    case "IDENTITY":
    case "SEX":
    case "YES_OR_NO":
    case "PROVINCE":
    case "CITY":
    case "CITY_LEVEL":
    case "DEVICE_KIND":
    case "DEVICE_PRICE":
    case "USER_GRADE":
    case "AD_POSITION":
    case "TO_GROUP":
    case "FROM_GROUP":
    case "TO_OBJECT":
    case "AD_KIND":
    case "INPUT":
    case "MULTI_INPUT":
    case "LIKE_INPUT":
    case "BCZ_WORD_BOOK":
    case "BCZ_STAFF_UID":
      return false;
    case "DATE_RANGE":
      return true;
    default:
      if (format.startsWith("OPTS:")) {
        return false;
      } else {
        return true;
      }
  }
}

export const TimeFormatList = [
  {
    label: "日",
    value: "day",
  },
  {
    label: "周",
    value: "week",
  },
  {
    label: "月",
    value: "month",
  },
  {
    label: "年",
    value: "year",
  },
];

export const indicatorJoin = "$@#@$";
